module.exports = __webpack_public_path__ + "static/media/bestof_4.2695de12.jpg";